import {
  LIMIT_FIELDS,
  LimitDomains,
  LimitField,
  LimitIssue,
  LimitResult,
  LimitValues,
} from './types';
import { admissibleDomainEnds } from './interval';
import { validateLimitValues } from './domains';

export function deriveDefaultLimits(
  domains: LimitDomains,
): LimitResult<LimitValues> {
  const values = {} as Record<LimitField, number>;
  const issues: LimitIssue[] = [];
  for (const field of LIMIT_FIELDS) {
    const domain = domains[field];
    const ends = admissibleDomainEnds(domain);
    const value =
      domain.defaultValue ??
      (field.startsWith('min') ? ends.minimum : ends.maximum);
    if (value === undefined)
      issues.push({
        code: 'DEFAULT_UNAVAILABLE',
        field,
        message:
          'Open continuous endpoint requires an explicit default or policy.',
      });
    else values[field] = value;
  }
  if (issues.length) return { ok: false, issues: Object.freeze(issues) };
  const validation = validateLimitValues(values, domains);
  return validation.length
    ? { ok: false, issues: validation }
    : { ok: true, value: Object.freeze(values) };
}
